define('Store.Item.PriceByStore', [
    'Profile.Model',
    'Store.Item.Price.Helper',
    'underscore',
    'Utils',
    'SC.Configuration'
], function ItemKeyMappingThumbnail(
    Profile,
    Helper,
    _,
    Utils,
    Configuration
) {
    'use strict';

    Configuration.itemKeyMapping = Configuration.itemKeyMapping || {};
    _.extend(Configuration.itemKeyMapping, {
        _priceDetails: function _priceDetails(item) {
            var profile = Profile.getInstance();
            var finalStore = item.get('store') || profile.get('store');
            var pricelevel = profile.get('priceLevel');
            var defaultPricelevel = SC.ENVIRONMENT.siteSettings.defaultpricelevel;

            if (pricelevel !== defaultPricelevel) {
                return item.get('onlinecustomerprice_detail');
            }

            if (!finalStore) {
                console.error('COULDN\'t find store');
            }

            if (!item.get('_soldInStore')) {
                return {
                    onlinecustomerprice: undefined,
                    onlinecustomerprice_formatted: undefined
                };
            }

            return {
                onlinecustomerprice: Helper.onlinecustomerprice(item, finalStore, pricelevel),
                onlinecustomerprice_formatted: Helper.onlinecustomerprice_formatted(item, finalStore, pricelevel),
                priceschedule: item.get('priceschedule')
            };
        },

        // @property {String} _price
        _price: function _price(item) {
            var profile = Profile.getInstance();
            var finalStore = item.get('store') || profile.get('store');
            var pricelevel = profile.get('priceLevel');
            var defaultPricelevel = SC.ENVIRONMENT.siteSettings.defaultpricelevel;
            var onlineCustomerPrice;

            if (pricelevel !== defaultPricelevel) {
                if (item.get('onlinecustomerprice_detail') &&
                    item.get('onlinecustomerprice_detail').priceschedule &&
                    item.get('onlinecustomerprice_detail').priceschedule.length) {
                    onlineCustomerPrice = _.findWhere(item.get('onlinecustomerprice_detail').priceschedule, { minimumquantity: 1 });
                    if (onlineCustomerPrice) {
                        return onlineCustomerPrice.price;
                    }
                }
                return (
                    (item.get('onlinecustomerprice_detail') &&
                        item.get('onlinecustomerprice_detail').onlinecustomerprice) ||
                    ''
                );
            }

            if (!finalStore) {
                console.error('COULDN\'t find store');
            }
            if (!item.get('_soldInStore')) {
                return undefined;
            }

            onlineCustomerPrice = Helper.onlinecustomerprice(item, finalStore, pricelevel);
            return onlineCustomerPrice && parseFloat(onlineCustomerPrice, 10);
        },

        // @property {String} _price_formatted
        // eslint-disable-next-line camelcase
        _price_formatted: function _price_formatted(item) {
            var profile = Profile.getInstance();
            var finalStore = item.get('store') || profile.get('store');
            var pricelevel = profile.get('priceLevel');
            var defaultPricelevel = SC.ENVIRONMENT.siteSettings.defaultpricelevel;
            var onlineCustomerPrice;

            if (pricelevel !== defaultPricelevel) {
                if (item.get('onlinecustomerprice_detail') &&
                    item.get('onlinecustomerprice_detail').priceschedule &&
                    item.get('onlinecustomerprice_detail').priceschedule.length) {
                    onlineCustomerPrice = _.findWhere(item.get('onlinecustomerprice_detail').priceschedule, { minimumquantity: 1 });
                    if (onlineCustomerPrice) {
                        return onlineCustomerPrice.price_formatted;
                    }
                }
                return (
                    (item.get('onlinecustomerprice_detail') &&
                        item.get('onlinecustomerprice_detail').onlinecustomerprice_formatted) ||
                    ''
                );
            }

            if (!finalStore) {
                console.error('COULDN\'t find store');
            }
            if (!item.get('_soldInStore')) {
                return undefined;
            }
            return Helper.onlinecustomerprice_formatted(item, finalStore, pricelevel);
        },
        _comparePriceAgainst: function _comparePriceAgainst(item) {
            var finalStore = item.get('store') || Profile.getInstance().get('store');
            if (!finalStore) {
                console.error('COULDN\'t find store');
            }
            return Helper.baseprice(item, finalStore);
        },
        _comparePriceAgainstFormated: function _comparePriceAgainstFormatted(item) {
            var finalStore = item.get('store') || Profile.getInstance().get('store');
            if (!finalStore) {
                console.error('COULDN\'t find store');
            }
            return Helper.baseprice_formatted(item, finalStore);
        }
    });
});
